exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.title[data-v-57bd4472] {\n  margin-bottom: 15px;\n}\ntable[data-v-57bd4472] {\n  text-align: left;\n}\ntable th[data-v-57bd4472], table td[data-v-57bd4472] {\n    min-width: 100px;\n    padding: 5px 15px 5px 0px;\n}\ntable th.name[data-v-57bd4472], table td.name[data-v-57bd4472] {\n      min-width: 200px;\n}\ntable input[data-v-57bd4472] {\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 4px 8px;\n    width: 100%;\n}\ntable .totals[data-v-57bd4472] {\n    font-weight: bold;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-57bd4472","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/settings/components/budget.vue
// module id = 571
// module chunks = 0